import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import {
  ReportHeading,
  LoaderWrapper,
  ReportOuterWrapper,
} from '../../../../components'
import ReportsService from '../../../../services/reports.service'
import { useUpdateLhs, useReactQuery } from '../../../../hooks'
import { useExportToPptObjects } from '../../../../hooks/useExportToPptObjects'
import { useGlobalStore } from '../../../../store'
import ReportEditSnapshot from './reportEditSnapshot'
import ReportViewSnapshot from './reportViewSnapshot'
import { ROLES_MM_PRIMARY } from '../../../../constants'
import { sortByKey, getObjectAsArray } from '../../../../util'
import { OuterWrapper, InnerWrapper, ContentWrapper } from './style'
import EditWidget from './editWidget'

const ReportSnapshot = (props) => {
  const [loading, setLoading] = useState()
  const [pageData, setPageData] = useState()
  const [widgetData, setWidgetData] = useState()
  const [editWidgetData, setEditWidgetData] = useState()
  const [targetID, setTargetID] = useState()
  const [showAddContentModal, setShowAddContentModal] = useState(false)
  const { user, projectIdValue, isPPTModalActive, isSnapshotModalActive, isFullScreen, exportToPptObject, setExportToPptObject } = useGlobalStore()
  const { updateSubLhsApiLoaded } = useUpdateLhs()
  const { updatingExportToPptObject } = useExportToPptObjects()

  const loadReportSnapshot = (getLatest = true) => {
    setLoading(true)
    ReportsService.reportGetSnapshotElementResultApi(
      { insightsElementId: props.InsightsElementId },
      getLatest
    )
      .then((resp) => {
        const orderingCol = sortByKey(getObjectAsArray(resp.SnapshotWidgets.SnapshotWidget), 'SnapshotWidgetLocationColumn')
        const orderingRow = sortByKey(orderingCol, 'SnapshotWidgetLocationRow')
        const convertRespTpWdigetData = (orderingRow).map((d, i) => (
          {
            orderBy : i,
            guid : d.SnapshotWidgetId,
            id : d.SnapshotWidgetNumber,
            height : d.SnapshotWidgetHeight,
            width : d.SnapshotWidgetWidth,
            title: d.SnapshotWidgetTitle,
            type: d.SnapshotWidgetType,
            json: d.SnapshotWidgetBlob,
            row: d.SnapshotWidgetLocationRow,
            col: d.SnapshotWidgetLocationColumn
          }
        ))
        setWidgetData(convertRespTpWdigetData)
        setPageData(convertRespTpWdigetData)
        
        const key = props.InsightsElementType + '__' + props.InsightsElementId.replaceAll('-', '_')
        const obj = { [key]: convertRespTpWdigetData }
        updatingExportToPptObject(obj)

        setTimeout(() => {
          updateSubLhsApiLoaded(props)
        }, 2000)
        setLoading(false)
      })
      .catch((error) => {
        const resMessage = error
        console.log('ERROR : ', resMessage)
        setLoading(false)
      })
  }

  const onSuccess = (param) => {
    loadReportSnapshot(true)
    setWidgetData(param)
  }

  const SnapshotEditButton = () => {
    return (
      <>
        {ROLES_MM_PRIMARY.includes(user?.UserType) && !loading && !projectIdValue?.IsFreezed && (
          <ReportEditSnapshot
            InsightsElementId={props.InsightsElementId}
            pageData={pageData || ''}
            onSuccess={onSuccess}
          />
        )}
      </>
    )
  }

  const onClickAddContentFunc = (d) => {
    setEditWidgetData(d)
    setShowAddContentModal(true)
  }

  const onClickEditContentFunc = (d) => {
    setEditWidgetData(d)
    setShowAddContentModal(true)
  }

  const onWidgetUpdatedFunc = () => {
    loadReportSnapshot(true)
    setShowAddContentModal(false)
  }

  useEffect(() => {
    if (!pageData) {
      loadReportSnapshot()
    }

    const targetID = `id_${(props.Title).replace(' ','')}_${props.InsightsElementId.replaceAll('-','')}`
    setTargetID(targetID)
  }, [])

  // useEffect(() => {
  //   setTimeout(() => {
  //     loadReportSnapshot()
  //   }, 1000)
  // }, [isFullScreen])

  useEffect(() => {
    const tId = document.getElementById(targetID)
    if(tId){
      tId.style.minHeight = '0px'

      if((isPPTModalActive || props.visibility==='visible')){
        tId.style.background = '#F6F6F5'
        tId.style.display = 'flex'
        tId.style.alignItems = 'baseline'
        tId.style.minHeight = document.getElementById('reportsContentSection').getBoundingClientRect().height + 'px'
        if(isPPTModalActive) {
          tId.style.background = '#ffffff'
        }
      } else {
        tId.style.minHeight = '0px'
      }
    }
  }, [targetID])

  useEffect(() => {
    if(!(isSnapshotModalActive && isPPTModalActive) && targetID){
      const tId = document.getElementById(targetID)
      if(tId) tId.style.minHeight = '0px'
    }
  }, [isSnapshotModalActive, isPPTModalActive, targetID])

  return (
    <>
      {(props.visibility==='visible' || isPPTModalActive) && <ReportHeading
        downloadId={isPPTModalActive ? props.type : null}
        subHeading=''
        {...props}
        additionalMiddleButton={<SnapshotEditButton />}
        addTable={false}
        showObservations={false}
      />}
      <ReportOuterWrapper style={{display: (props.visibility==='visible' || isPPTModalActive) ? 'flex' : 'none'}}>
        <OuterWrapper id={props.type} className={`sandBoxing ${props.InsightsElementType} ${isPPTModalActive ? 'exportToPPT' : ''}`}>
          {(props.visibility==='visible' || isPPTModalActive) && <LoaderWrapper loadOnlyApi={props.loadOnlyApi} loading={loading}>
            <InnerWrapper>
              {targetID?.length > 0 && widgetData?.length > 0 && <ReportViewSnapshot data={widgetData} id={targetID} onClickAddContent={onClickAddContentFunc} onClickEditContent={onClickEditContentFunc} />}
              {showAddContentModal && <EditWidget insightsElementId={props.InsightsElementId} data={editWidgetData} onClose={() => setShowAddContentModal(false)} onClickEditContent={onClickEditContentFunc} onWidgetUpdated={onWidgetUpdatedFunc} />}
            </InnerWrapper>
          </LoaderWrapper>}
        </OuterWrapper>
      </ReportOuterWrapper>
    </>
  )
}

export default ReportSnapshot
